export default function Diamond({ style }) {
  return (
    <svg
      className={style}
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_3072_28369)'>
        <path
          d='M30.96 7.65734L26.9453 2.23334C26.4516 1.54311 25.8005 0.980492 25.046 0.592102C24.2915 0.203712 23.4553 0.000738294 22.6066 2.34985e-06H9.39332C8.54883 -0.000790313 7.71622 0.198966 6.96402 0.582833C6.21181 0.9667 5.56152 1.5237 5.06665 2.208L0.979982 7.67067C0.3146 8.60892 -0.0290247 9.73743 0.000539016 10.8873C0.0301027 12.0372 0.431265 13.1465 1.14398 14.0493L12.8666 30.4867C13.2402 30.9597 13.7164 31.3417 14.2592 31.6039C14.802 31.8661 15.3972 32.0015 16 32C16.6131 31.9988 17.2178 31.8569 17.7675 31.5853C18.3171 31.3137 18.7972 30.9196 19.1707 30.4333L30.8 14.1787C31.5446 13.2626 31.9643 12.1255 31.9933 10.9453C32.0222 9.76517 31.6588 8.60877 30.96 7.65734ZM24.7893 3.80134L28.8133 9.23867C28.8347 9.268 28.84 9.30267 28.8613 9.33334H22.3386L20.4347 2.66667H22.6066C23.0346 2.668 23.456 2.77168 23.8357 2.96907C24.2154 3.16646 24.5424 3.45183 24.7893 3.80134ZM16 25.4907L12.4 12H19.6L16 25.4907ZM12.4346 9.33334L14.3386 2.66667H17.6613L19.5653 9.33334H12.4346ZM7.22265 3.78267C7.47005 3.43785 7.79591 3.15682 8.17334 2.96278C8.55076 2.76873 8.96893 2.66724 9.39332 2.66667H11.5653L9.66131 9.33334H3.09065C3.10932 9.304 3.11465 9.268 3.13598 9.24L7.22265 3.78267ZM3.26398 12.4333C3.16771 12.2974 3.08509 12.1522 3.01731 12H9.64265L13.6346 26.9733L3.26398 12.4333ZM18.3613 26.9867L22.3613 12H29.0093C28.9234 12.199 28.8147 12.3874 28.6853 12.5613L18.3613 26.9867Z'
          fill='#8FC045'
        />
      </g>
      <defs>
        <clipPath id='clip0_3072_28369'>
          <rect width='32' height='32' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
